import {
  CreateWebsiteDTO,
  CreateMainWebsiteDTO,
  CreateWebsiteAliasDTO,
  CreateWebsiteSubdomainDTO,
} from '../../../../shared/models/website-create.models';
import { WebsiteEnvironment } from '../../../../shared/models/website.models';
import { TemporaryWPCredentials } from '../../../../shared/models/wordpress.models';
import { WebsiteFormValue, WPFormValue } from './add-website-dialog.models';

export interface CurrentUserContext {
  id: string;
  isAdmin: boolean;
}

function mapToExcludeActions(formValue: WebsiteFormValue, includeWordPress = true): string[] {
  return [
    !formValue.enableEmail ? 'email' : '',
    includeWordPress && !formValue.installWordpress ? 'wp' : '',
  ].filter(Boolean);
}

export function mapToWebsiteCreateRequest(formValue: WebsiteFormValue): CreateWebsiteDTO {
  return {
    originServer: formValue.originServer,
    domain: formValue.domain,
    groupId: Number(formValue.groupId),
    userId: formValue.userId,
    excludeActions: mapToExcludeActions(formValue),
  };
}

export function mapToMainWebsiteCreateRequest(
  formValue: WebsiteFormValue,
  currentUser: CurrentUserContext,
): CreateMainWebsiteDTO {
  return {
    originServer: formValue.originServer,
    domain: formValue.domain,
    userId: currentUser.isAdmin ? formValue.userId : currentUser.id,
    plan: Number(formValue.plan),
    excludeActions: mapToExcludeActions(formValue),
  };
}

export function mapToAliasCreateRequest(formValue: WebsiteFormValue): CreateWebsiteAliasDTO {
  return {
    websiteId: Number(formValue.websiteId),
    domain: formValue.domain,
    websiteEnvironment: WebsiteEnvironment.ALIAS,
    excludeActions: mapToExcludeActions(formValue, false),
  };
}

export function mapToSubdomainCreateRequest(
  formValue: WebsiteFormValue,
): CreateWebsiteSubdomainDTO {
  return {
    websiteId: Number(formValue.websiteId),
    domain: formValue.domain + formValue.subdomainMain,
    websiteEnvironment: WebsiteEnvironment.SUB,
    excludeActions: mapToExcludeActions(formValue),
  };
}

export function mapToWPCredentialsRequest(formValue: WPFormValue): TemporaryWPCredentials {
  return {
    domain: formValue.domain,
    user: formValue.user,
    password: formValue.password,
    email: formValue.email,
    enableRedisCache: formValue.enableRedisCache,
    plugins: [
      formValue.enableW3TotalCache ? 'w3tc' : '',
      formValue.enableWooCommerce ? 'wc' : '',
    ].filter(Boolean),
  };
}
